/* Produktwahl (Relaunch 19.09.2026): ersetzt das eine Auswahlfeld mit bis zu 80 Zeilen auf den
 * Produktseiten durch Knöpfe je Eigenschaft, Mengenfeld, Gesamtpreis und Bildwechsel.
 *
 * Daten kommen aus window.RZ_PRODUKT (templates/product.liquid), also ausschließlich aus den
 * Shopify-Varianten. Hier steht kein Preis und keine Artikelnummer fest im Code.
 *
 * Regeln aus dem alten Auswahlfeld, die erhalten bleiben (Kevin 10.08.2026):
 *  - Doppelstabmatte: Befestigung ist fest "Einbetonieren" (die Matte ist in beiden Fällen dieselbe).
 *  - Zaunpfosten/Eckpfosten: Drahtstärke ist fest "6/5/6" (Pfosten für beide Stärken cent-gleich),
 *    die Befestigung bleibt wählbar, weil sie den Preis ändert.
 *  - Pfosten mit Abdeckleiste: der Aufpreis-Artikel wandert als ZWEITE Position in den Warenkorb,
 *    in derselben Menge.
 * Ohne JavaScript bleibt das Auswahlfeld im <noscript> stehen, der Kauf geht weiter.
 */
(function () {
  "use strict";
  var D = window.RZ_PRODUKT;
  var wurzel = document.querySelector("[data-rz-wahl]");
  if (!D || !wurzel) return;

  var FARBEN = {
    "Anthrazit": "#34383b", "Moosgrün": "#28533a", "Verzinkt": "#b7bdbf", "Schwarz": "#1d1d1b",
    "Grün": "#28533a", "Grau": "#8d9295", "Fenstergrau": "#9da3a6", "Edelstahl": "#c9cdd0"
  };
  var MASS = /h(ö|oe)he|l(ä|ae)nge|breite|ma(ß|ss)|gr(ö|oe)(ß|ss)e/i;
  var FEST = D.fest || {};

  function geld(cent) {
    return (cent / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  // Varianten in Gruppen zerlegen. Die Shopify-Option "System" trägt zwei Angaben ("6/5/6 · 1230 mm").
  var namen = [];
  D.optionen.forEach(function (n) {
    if (n === "System") { namen.push("Drahtstärke"); namen.push("Höhe"); } else { namen.push(n === "Montage" ? "Befestigung" : n); }
  });
  var alleVarianten = D.varianten.map(function (v) {
    var w = {};
    var i = 0;
    D.optionen.forEach(function (n, k) {
      var wert = v.o[k];
      if (n === "System") {
        var teile = String(wert).split(" · ");
        w[namen[i++]] = teile[0];
        w[namen[i++]] = teile.slice(1).join(" · ");
      } else { w[namen[i++]] = wert; }
    });
    return { id: v.id, preis: v.preis, verf: v.verf, bild: v.bild, gp: v.gp, gpe: v.gpe, w: w };
  });
  var varianten = alleVarianten.filter(function (v) {
    for (var n in FEST) { if (v.w[n] !== undefined && v.w[n] !== FEST[n]) return false; }
    return true;
  });
  var gruppen = namen.filter(function (n) { return FEST[n] === undefined; }).map(function (n) {
    var werte = [];
    varianten.forEach(function (v) { if (werte.indexOf(v.w[n]) < 0) werte.push(v.w[n]); });
    return { name: n, werte: werte };
  }).filter(function (g) { return !(g.werte.length === 1 && g.werte[0] === "Default Title"); });
  // Farbe zuerst: sie entscheidet das Bild, und die Frage ist die leichteste.
  gruppen.sort(function (a, b) { return (b.name === "Farbe") - (a.name === "Farbe"); });

  var stand = {};
  var menge = 1;
  var leiste = false;

  function passende(teil) {
    return varianten.filter(function (v) {
      for (var n in teil) { if (teil[n] != null && v.w[n] !== teil[n]) return false; }
      return true;
    });
  }
  function gewaehlt() {
    for (var i = 0; i < gruppen.length; i++) { if (stand[gruppen[i].name] == null) return null; }
    var p = passende(stand);
    return p.length === 1 ? p[0] : null;   // mehrdeutig (neue Option am Produkt) = keine Auswahl, nie still die erste nehmen
  }
  function ersteLuecke() {
    for (var i = 0; i < gruppen.length; i++) { if (stand[gruppen[i].name] == null) return gruppen[i]; }
    return null;
  }

  // Startbelegung: Variante aus der Adresse, sonst alles außer Maßen vorbelegt (ein Maß wählt der Kunde bewusst).
  // Befund 06.10.2026: Google Shopping schickt 56 % der Klicks auf Aufdübeln-Varianten der Matte. Die sind
  // oben wegen FEST aussortiert, die Variante aus der Adresse wurde nicht gefunden, nichts war vorbelegt.
  // Deshalb in ALLEN Varianten suchen und die wählbaren Eigenschaften (Höhe, Farbe, Stärke) übernehmen;
  // die feste Eigenschaft bleibt fest.
  var ausAdresse = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
  var start = ausAdresse ? alleVarianten.filter(function (v) { return String(v.id) === ausAdresse; })[0] : null;
  gruppen.forEach(function (g) {
    if (start) { stand[g.name] = start.w[g.name]; return; }
    if (g.werte.length === 1) { stand[g.name] = g.werte[0]; return; }
    stand[g.name] = null;
  });
  // Umbau 08.10.2026 (Review Punkt 2): ohne Variante in der Adresse zuerst die Hausvorwahl (D.vorwahl aus product.liquid:
  // Set/Matte 1230 mm, 6/5/6, Anthrazit, Einbetonieren; Tor 100 cm, 1200 mm, Anthrazit). Auch Maße, aber nur, wenn es den
  // Wert gibt und mit den bisher gesetzten Angaben eine lieferbare Variante übrig bleibt. Sonst bleibt die Lücke offen.
  var VORWAHL = D.vorwahl || {};
  var vorgewaehlt = false;
  if (!start) {
    gruppen.forEach(function (g) {
      var w = VORWAHL[g.name];
      if (stand[g.name] != null || w == null || g.werte.indexOf(w) < 0) return;
      var versuch = {}; for (var n in stand) versuch[n] = stand[n];
      versuch[g.name] = w;
      if (passende(versuch).some(function (v) { return v.verf; })) { stand[g.name] = w; vorgewaehlt = true; }
    });
  }
  if (!start) {
    gruppen.forEach(function (g) {
      if (stand[g.name] != null || MASS.test(g.name)) return;
      var versuch = {}; for (var n in stand) versuch[n] = stand[n];
      for (var i = 0; i < g.werte.length; i++) {
        versuch[g.name] = g.werte[i];
        if (passende(versuch).some(function (v) { return v.verf; })) { stand[g.name] = g.werte[i]; break; }
      }
    });
  }

  // Aufbau: je Eigenschaft eine Gruppe aus Kacheln (Radio + sichtbare Kachel, Klassen aus rz-relaunch.css)
  var felder = wurzel.querySelector("[data-rz-gruppen]");
  var FARB_KLASSE = { "Anthrazit": "anthrazit", "Moosgrün": "moosgruen", "Verzinkt": "verzinkt" };
  var UNTERZEILE = D.unterzeilen || {};
  gruppen.forEach(function (g, nr) {
    var fs = document.createElement("fieldset");
    fs.className = "rz-wahl";
    fs.setAttribute("data-gruppe", g.name);
    var lg = document.createElement("legend");
    lg.appendChild(document.createTextNode(g.name));
    var gewaehltAnzeige = document.createElement("span"); gewaehltAnzeige.setAttribute("data-rz-wert", ""); lg.appendChild(gewaehltAnzeige);
    fs.appendChild(lg);
    var laengste = g.werte.reduce(function (m, w) { return Math.max(m, String(w).length); }, 0);
    var raster = document.createElement("div");
    raster.className = "rz-wahl-raster" + (laengste > 24 ? " rz-wahl-raster--1" : (g.name === "Farbe" || (laengste > 9 && g.werte.length % 3 === 0) ? " rz-wahl-raster--3" : (laengste <= 9 && g.werte.length >= 4 ? " rz-wahl-raster--4" : "")));
    g.werte.forEach(function (w) {
      var l = document.createElement("label");
      var r = document.createElement("input");
      r.type = "radio"; r.name = "rz-gruppe-" + nr; r.value = w;
      r.addEventListener("change", function () { waehlen(g.name, w); });
      var k = document.createElement("span");
      if (g.name === "Farbe") {
        k.className = "rz-farbe" + (FARB_KLASSE[w] ? " rz-farbe--" + FARB_KLASSE[w] : "");
        if (!FARB_KLASSE[w] && FARBEN[w]) k.style.setProperty("--rz-punkt", FARBEN[w]);
        k.textContent = w;
      } else {
        k.className = "rz-kachel";
        var teile = String(w).match(/^([\d.,\/]+)\s*(mm|cm|m|ml)$/);
        var fett = document.createElement("b"); fett.textContent = teile ? teile[1] : w; k.appendChild(fett);
        var klein = (UNTERZEILE[g.name] || {})[w] || (teile ? teile[2] : "");
        if (klein) { var s = document.createElement("small"); s.textContent = klein; k.appendChild(s); }
      }
      l.appendChild(r); l.appendChild(k); raster.appendChild(l);
    });
    fs.appendChild(raster);
    var hinweis = (D.hinweise || {})[g.name];
    if (hinweis) { var h = document.createElement("p"); h.className = "rz-klein rz-wahl-hinweis"; h.textContent = hinweis; fs.appendChild(h); }
    felder.appendChild(fs);
  });

  function waehlen(name, wert) {
    stand[name] = wert;
    // Gibt es die Kombination nicht, die übrigen Angaben von hinten lösen, bis wieder etwas passt.
    // Erst versuchen, mit dem Lösen EINER anderen Angabe auszukommen (z. B. nur die Befestigung, nicht auch die Höhe).
    if (passende(stand).length === 0) {
      for (var k = gruppen.length - 1; k >= 0; k--) {
        var n1 = gruppen[k].name; if (n1 === name || stand[n1] == null) continue;
        var probe = {}; for (var x in stand) probe[x] = stand[x]; probe[n1] = null;
        if (passende(probe).length) { stand[n1] = null; break; }
      }
    }
    var i = gruppen.length - 1;
    while (passende(stand).length === 0 && i >= 0) {
      if (gruppen[i].name !== name) stand[gruppen[i].name] = null;
      i--;
    }
    wurzel.classList.remove("rz-fehlt");
    zeichnen(true);
  }

  var elPreis = document.querySelector("[data-rz-preis]");
  var elSumme = wurzel.querySelector("[data-rz-summe]");
  var elKnopf = wurzel.querySelector("[data-rz-kaufen]");
  var elId = wurzel.querySelector('input[name="id"]');
  var elMenge = wurzel.querySelector("[data-rz-menge]");
  var elBild = document.querySelector("[data-rz-hauptbild]");
  var elLeiste = wurzel.querySelector("[data-rz-leiste]");
  var elLeisteHinweis = wurzel.querySelector("[data-rz-leiste-hinweis]");
  var elStatus = wurzel.querySelector("[data-rz-status]");
  var leisteUnten = document.querySelector("[data-rz-kaufleiste]");

  function alVariante(v) {
    if (!v || !D.abdeckleiste) return null;
    var hoehe = String(v.w["Höhe"] || "").replace(/\D/g, "");
    return D.abdeckleiste[hoehe] || null;
  }

  var bahn = document.querySelector("[data-rz-bahn]");
  function bildSetzen(url, alt) {
    if (!elBild || !url) return;
    elBild.src = url; elBild.removeAttribute("srcset"); if (alt) elBild.alt = alt;
    var d1 = document.querySelector("[data-rz-daumen] img"); if (d1) d1.src = url;
    if (bahn) bahn.scrollTo({ left: 0 });
  }

  // Zaunfluss 08.10.2026: nur Planer-Link, aktueller Stand einschließlich fester Eigenschaften.
  function planerLinks() {
    var w = Object.assign({}, stand, FEST);
    document.querySelectorAll('[data-rz-planer-link]').forEach(function (link) {
      var p = new URLSearchParams(); p.set('l', link.dataset.zfLaenge || '20');
      var h = String(w['Höhe'] || '').match(/^(\d+) mm$/);
      if (h) p.set('h', h[1]);
      var f = {'Anthrazit':'ant', 'Moosgrün':'moo', 'Verzinkt':'ver'}[w.Farbe]; if (f) p.set('f', f);
      var s = {'6/5/6':'656', '8/6/8':'868'}[w['Drahtstärke']]; if (s) p.set('s', s);
      var b = {'Einbetonieren':'ein', 'Aufdübeln':'auf'}[w.Befestigung]; if (b) p.set('b', b);
      link.href = link.dataset.zfRoot + '?' + p.toString() + '#konfigurator';
    });
  }

  function zeichnen(bildWechseln) {
    planerLinks(); // Zaunfluss 08.10.2026: Startauswahl und jede Änderung.
    gruppen.forEach(function (g) {
      var fs = felder.querySelector('[data-gruppe="' + g.name + '"]');
      fs.querySelector("[data-rz-wert]").textContent = stand[g.name] != null ? stand[g.name] : "bitte wählen";
      fs.classList.toggle("rz-wahl--offen", stand[g.name] == null);
      fs.querySelectorAll("input").forEach(function (r) {
        var versuch = {}; for (var n in stand) versuch[n] = stand[n];
        versuch[g.name] = r.value;
        var treffer = passende(versuch);
        var moeglich = treffer.some(function (v) { return v.verf; });
        r.checked = stand[g.name] === r.value;
        // Nicht "disabled": ein Klick auf eine nicht passende Kachel soll die übrige Auswahl lösen statt nichts zu tun.
        r.nextElementSibling.classList.toggle("rz-kachel--aus", !moeglich);
        r.parentNode.title = moeglich ? "" : (treffer.length ? "Zurzeit nicht lieferbar" : "Mit Ihrer übrigen Auswahl nicht erhältlich, ein Klick stellt um");
      });
    });
    var v = gewaehlt();
    var al = leiste ? alVariante(v) : null;
    if (elLeisteHinweis) {
      var alInfo = alVariante(v);
      elLeisteHinweis.textContent = v ? (alInfo ? "+ " + geld(alInfo.preis) + " je Pfosten" : "für diese Höhe nicht erhältlich") : "";
    }
    var elGp = document.querySelector("[data-rz-grundpreis]");
    if (elGp) { elGp.hidden = !(v && v.gp != null && v.gpe); if (!elGp.hidden) elGp.textContent = "Grundpreis: " + geld(v.gp) + " je " + v.gpe; }
    if (v) {
      var stueck = v.preis + (al ? al.preis : 0);
      if (elPreis) elPreis.textContent = geld(stueck);
      if (elSumme) elSumme.textContent = menge > 1 ? menge + " Stück = " + geld(stueck * menge) : "";
      if (elId) elId.value = v.id;
      elKnopf.textContent = v.verf ? "In den Warenkorb" : "Zurzeit nicht lieferbar";
      elKnopf.disabled = !v.verf;
      if (bildWechseln !== false) {
        var bild = v.bild;
        if (leiste && window.ROST_BILDER && D.bildPraefix) {
          var slug = { "Anthrazit": "anthrazit", "Moosgrün": "moosgruen", "Verzinkt": "verzinkt" }[v.w["Farbe"]] || "anthrazit";
          bild = window.ROST_BILDER[D.bildPraefix + "-leiste-" + slug] || bild;
        }
        if (!bild && D.farbbilder && v.w["Farbe"]) bild = D.farbbilder[v.w["Farbe"]];
        bildSetzen(bild, D.titel + " " + gruppen.map(function (g) { return stand[g.name]; }).join(", "));
      }
    } else {
      var rest = passende(stand);
      var ab = rest.reduce(function (m, x) { return Math.min(m, x.preis); }, Infinity);
      if (elPreis && isFinite(ab)) elPreis.textContent = "ab " + geld(ab);
      if (elSumme) elSumme.textContent = "";
      var l = ersteLuecke();
      elKnopf.disabled = false;
      elKnopf.textContent = l ? "Bitte " + l.name + " wählen" : "In den Warenkorb";
      if (bildWechseln && D.farbbilder && stand["Farbe"] && D.farbbilder[stand["Farbe"]]) bildSetzen(D.farbbilder[stand["Farbe"]]);
    }
    if (leisteUnten) {
      leisteUnten.querySelector("[data-rz-kaufleiste-preis]").textContent = elPreis ? elPreis.textContent : "";
      leisteUnten.querySelector("[data-rz-kaufleiste-knopf]").textContent = elKnopf.textContent;
      leisteUnten.querySelector("[data-rz-kaufleiste-kurz]").textContent = gruppen.map(function (g) { return stand[g.name]; }).filter(Boolean).join(" · ") || D.titel;
    }
  }

  function mengeSetzen(n) {
    menge = Math.max(1, Math.min(999, parseInt(n, 10) || 1));
    if (elMenge) elMenge.value = menge;
    zeichnen(false);
  }
  wurzel.querySelectorAll("[data-rz-menge-schritt]").forEach(function (b) {
    b.addEventListener("click", function () { mengeSetzen(menge + Number(b.getAttribute("data-rz-menge-schritt"))); });
  });
  if (elMenge) elMenge.addEventListener("change", function () { mengeSetzen(elMenge.value); });
  if (elLeiste) elLeiste.addEventListener("change", function () {
    leiste = wurzel.querySelector('input[name="rz_ausfuehrung"]:checked').value === "leiste";
    zeichnen(true);
  });

  function kaufen(e) {
    if (e) e.preventDefault();
    var v = gewaehlt();
    if (!v) {
      var l = ersteLuecke();
      wurzel.classList.add("rz-fehlt");
      var ziel = l && felder.querySelector('[data-gruppe="' + l.name + '"]');
      if (ziel) { ziel.scrollIntoView({ behavior: "smooth", block: "center" }); var erstes = ziel.querySelector("input"); if (erstes) erstes.focus({ preventScroll: true }); }
      if (elStatus) elStatus.textContent = l ? "Bitte wählen Sie zuerst: " + l.name + "." : "";
      return;
    }
    if (!v.verf) return;
    var al = leiste ? alVariante(v) : null;
    var positionen = [{ id: v.id, quantity: menge }];
    if (al) { positionen[0].properties = { "Ausführung": "mit Abdeckleiste" }; positionen.push({ id: al.id, quantity: menge }); }
    elKnopf.disabled = true;
    if (elStatus) elStatus.textContent = "";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: positionen })
    }).then(function (a) {
      if (!a.ok) throw new Error("abgelehnt");
      elKnopf.disabled = false;
      if (window.RostKorb) window.RostKorb.oeffnen(); else window.location.href = "/cart";
    }).catch(function () {
      elKnopf.disabled = false;
      // Rückfall: klassisches Absenden. Geht nur ohne zweite Position sauber, sonst Meldung.
      if (al) { if (elStatus) elStatus.textContent = "Das hat nicht geklappt. Bitte versuchen Sie es noch einmal oder rufen Sie uns an."; return; }
      wurzel.querySelector("form").submit();
    });
  }
  wurzel.querySelector("form").addEventListener("submit", kaufen);
  if (leisteUnten) {
    leisteUnten.querySelector("[data-rz-kaufleiste-knopf]").addEventListener("click", function () { kaufen(); });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { leisteUnten.hidden = e[0].isIntersecting; }, { threshold: 0 }).observe(elKnopf);
    } else { leisteUnten.hidden = false; }
  }

  // Galerie: Zähler und Daumenbilder folgen der Wisch-Bahn
  var zaehler = document.querySelector("[data-rz-zaehler]");
  var daumen = [].slice.call(document.querySelectorAll("[data-rz-daumen]"));
  if (bahn) {
    bahn.addEventListener("scroll", function () {
      var i = Math.round(bahn.scrollLeft / bahn.clientWidth);
      if (zaehler) zaehler.textContent = (i + 1) + " / " + bahn.children.length;
      daumen.forEach(function (d, n) { d.setAttribute("aria-current", n === i ? "true" : "false"); });
    }, { passive: true });
    daumen.forEach(function (d, n) { d.addEventListener("click", function () { bahn.scrollTo({ left: n * bahn.clientWidth, behavior: "smooth" }); }); });
  }

  wurzel.classList.add("rz-bereit");
  zeichnen(!!start || vorgewaehlt);
})();
